import { TranslatedString } from "@web-monorepo/translation-runtime";
import React from "react";
import { DDSDialog, DDSDialogBody, DDSDialogContent, DDSDialogHeader } from "@web-monorepo/dds";
import type { AppPageVariant } from "./AppPage";
import AppRemoteCard from "./AppRemoteCard";
import CastControl from "src/pods/realtime/components/CastControl";

type AppModalProps = React.PropsWithChildren<{
  /**
   * Pod identifier — passed through to AppRemoteCard so its icon tile picks
   * up the pod's brand color. Only meaningful when `icon` is also set.
   */
  variant?: AppPageVariant;
  onRequestStart?: VoidFunction;
  onRequestStop?: VoidFunction;
  onRequestHide?: VoidFunction;
  className?: string;
  title?: TranslatedString;
  icon?: string;
}>;

function AppModal({
  children,
  variant,
  title,
  icon,
  onRequestStart,
  onRequestStop,
  onRequestHide,
  className,
}: AppModalProps) {
  const hasCastControl = onRequestStart && onRequestStop;

  return (
    <DDSDialog open data-name="app_modal:render:dds_dialog">
      <DDSDialogContent className={className}>
        <DDSDialogHeader visuallyHideTitle title={title} onClose={onRequestHide ?? (() => {})}>
          {hasCastControl && <CastControl onRequestStart={onRequestStart} onRequestStop={onRequestStop} />}
        </DDSDialogHeader>
        <DDSDialogBody>
          <AppRemoteCard variant={variant} title={title} icon={icon}>
            {children}
          </AppRemoteCard>
        </DDSDialogBody>
      </DDSDialogContent>
    </DDSDialog>
  );
}

export default AppModal;
